export default {
	methods: {
		cabecalhoRdvTour() {
      return {
        "cd_rdv": "999999",
        "dt_rdv": "2022-01-01 00:00:00",
        "dt_inicio": "2022-01-01 00:00:00",
        "dt_fim": "2022-01-01 00:00:00",
        "st_rdv": "A",
        "ds_st_rdv": "Aberto",
        "ds_cor_app_st_rdv": "#34C38F",
        "tp_rdv": "U",
        "vl_cartao_credito": "0",
        "vl_cartao_visa": "999.99",
        "vl_utilizacao_frota": "999.3994",
        "vl_adiantamento": "0",
        "vl_despesa": "999.99",
        "vl_previsao_acerto": "113",
        "vl_limite": "9999",
        "vl_disponivel": "999.999",
        "cd_pessoa": "999999",
        "nm_cooperado": "Fulano",
        "cd_projeto": "9999",
        "nm_projeto": "PROJETO COOPERADO UNICAMPO",
        "dt_referencia": "2022-01-01 00:00:00",
        "ds_dt_referencia": "Março",
        "cd_matriz": "99999",
        "nm_matriz": "EXEMPLO",
        "sq_contrato": "99",
        "nr_contrato": "EXEMPLO",
        "st_gera_cobranca": "S",
      }
		},
    dadosCardsTour() {
      return [
        {
          "sq_carteira": "5",
          "ds_carteira": "Visa",
          "ds_tipo_carteira": "V",
          "ds_icone_app": "assets/images/visa.png",
          "ds_cor_web": "#74788D",
          "ds_detalhe_carteira": "**** **** **** 9999",
          "vl_lcto": "999.99",
          "vl_movto": "999.99",
          "vl_disponivel": "0",
          "sq_ordenacao": "1",
          "ge_pessoa": {
              "nm_razao": "COOPERADO UNICAMPO",
          }
        },
        {
          "sq_carteira": "2",
          "ds_carteira": "Adiantamento",
          "ds_tipo_carteira": "A",
          "ds_icone_app": "assets/bank/001.png",
          "ds_cor_web": "#34C38F",
          "ds_detalhe_carteira": "99-9  999999-9",
          "vl_lcto": "999.99",
          "vl_movto": "999.99",
          "vl_disponivel": "99.99",
          "sq_ordenacao": "3",
          "ge_pessoa": {
            "nm_razao": "COOPERADO UNICAMPO",
          }
        },
        {
          "sq_carteira": "3",
          "ds_carteira": "Recurso próprio",
          "ds_tipo_carteira": "P",
          "ds_icone_app": "assets/images/carteira.png",
          "ds_cor_web": "#F1B44C",
          "dt_referencia": "2022-01-01 00:00:00",
          "ds_detalhe_carteira": " ",
          "vl_lcto": "999.99",
          "vl_movto": "999.99",
          "vl_disponivel": "0",
          "sq_ordenacao": "4",
          "ge_pessoa": {
            "nm_razao": "COOPERADO UNICAMPO",
          }
        },
      ]
    },
    tabelaDespesasTour(){
      return[
        {
          "ds_carteira": "Visa",
          "ds_tipo_carteira": "V",
          "dt_lancamento": "2022-01-11 00:00:00",
          "vl_original": "999.99",
          "st_lancamento": "NV",
          "ds_st_lancamento": "Não Vinculado",
          "estabelecimento_visa": "DESPESA TOUR",
          "cidade_uf_movimento": "CIDADE TOUR",
          "despesas": []
        },
        {
          "ds_carteira": "Recurso próprio",
          "ds_tipo_carteira": "P",
          "cd_norma": "111",
          "dt_lancamento": "2022-01-01 00:00:00",
          "vl_original": "999.99",
          "vl_lancamento": "999.99",
          "st_lancamento": "L",
          "ds_st_lancamento": "Liberado",
          "ds_norma": "ALMOÇO",
          "cidade_uf_movimento": "CIDADE TOUR",
          "despesas": []
        },
        {
          "ds_carteira": "Recurso próprio",
          "ds_tipo_carteira": "P",
          "cd_norma": "29",
          "dt_lancamento": "2022-01-01 00:00:00",
          "vl_original": "555.55",
          "vl_lancamento": "555.55",
          "st_lancamento": "L",
          "ds_st_lancamento": "Liberado",
          "ds_norma": "LAVAGEM DE VEÍCULO",
          "cidade_uf_movimento": "CIDADE TOUR",
          "despesas": []
        },
        {
          "ds_carteira": "Recurso próprio",
          "ds_tipo_carteira": "P",
          "cd_norma": "7",
          "dt_lancamento": "2022-01-01 00:00:00",
          "vl_original": "777.99",
          "vl_lancamento": "777.77",
          "st_lancamento": "L",
          "ds_st_lancamento": "Liberado",
          "ds_norma": "HOSPEDAGEM",
          "cidade_uf_movimento": "CIDADE TOUR",
          "despesas": []
        },
        {
          "ds_carteira": "Visa",
          "ds_tipo_carteira": "V",
          "dt_lancamento": "2022-03-21 00:00:00",
          "vl_original": "10",
          "st_lancamento": "NV",
          "ds_st_lancamento": "Não Vinculado",
          "estabelecimento_visa": "DESPESA TOUR",
          "cidade_uf_movimento": "CIDADE TOUR",
          "despesas": [
              {
                  "dt_lancamento": "2022-03-17 00:00:00",
                  "vl_original": "10",
                  "vl_lancamento": "10",
                  "st_lancamento": "R",
                  "ds_st_lancamento": "Rejeitado",
                  "ds_norma": "CAFÉ DA TARDE",
                  "cidade_uf_movimento": "CIDADE TOUR",
                  "despesas": []
              }
          ],
          "_showDetails": true
        }
      ]
    },
    veiculosTour(){
      return {
        "sq_veiculo": "1",
        "dt_inicial": "2022-01-01 00:00:00",
        "dt_final": "2022-12-31 00:00:00",
        "qt_km_inicial": "99999",
        "qt_km_final": "99999",
        "qt_km_particular": "0",
        "qt_km_percorrido": "9999",
        "km_atual": "99999",
        "ds_placa": "UNI-C4MP0",
        "nm_versao": "CARRO COOPERADO UNICAMPO",
        "nm_categoria": "UTILITÁRIO CABINE SIMPLES",
        "cd_marca": "4",
        "dt_gerenciamento": "2022-01-01 00:00:00",
        "st_aprovado": "N",
        "ds_aprovado": "Em análise",
        "sq_lancamento": "1",
        "vl_lancamento": "999.99"
      }
    },
    guiaTour(){
      return [
        {
          target: '[data-v-step="1"]',
          content: 'Aqui você pode consultar os seus RDVs.',
          params: {
            placement: 'right',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="2"]',
          content: 'Consulte seus Projetos aqui',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="3"]',
          content: 'Veja o mês de referência aqui',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="4"]',
          content: 'Clique no botão Limpar para limpar os campos',
          params: {
            placement: 'left',
            highlight: false,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="5"]',
          content: ' Quando estiver com os campos acima preenchidos, clique em <strong>Filtrar</strong> para consultar o RDV ',
          params: {
            placement: 'left',
            highlight: false,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="6"]',
          content: 'Visualize aqui as informações do RDV consultado: <br><strong> Status do RDV: </strong>Aberto, Reaberto, Fechado, Enviado, Liberado e Liquidado;<br><strong>O Período do RDV</strong> (1 mês);<br><strong>Projeto do RDV.</strong></strong>',
          params: {
            placement: 'right',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="7"]',
          content: ' Passe o mouse por cima desse ícone para visualizar o detalhamento de alguma informação',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="8"]',
          content: 'Aqui está o card de Valores do seu RDV',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="9"]',
          content: 'Aqui está um gráfico dos Valores, sendo:<br><strong>azul</strong> - despesas já lançadas;<br> <strong>verde</strong> - disponível para lançamento;',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="10"]',
          content: ' Clique para visualizar o relatório de Folha de Rosto e Comprovante.',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="11"]',
          content: 'Quando o RDV estiver com o status de <strong>LIQUIDADO</strong>, o botão Extrato do Acerto irá aparecer ao lado do de Folha de Rosto como no exemplo.',
          params: {
            placement: 'top',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="12"]',
          content: 'Essas são suas <strong>carteiras disponíveis</strong>.<br> Aqui você pode fazer o lançamento de despesas e movimentações.<br> As movimentações relacionadas as carteiras de Good Card e Cartão de Crédito estão listadas abaixo na tabela <strong>Transações e Despesas</strong>',
          params: {
            placement: 'top',
            highlight: true,
            enableScrolling: true
          }
        },
        {
          target: '[data-v-step="13"]',
          content: 'Abaixo das carteiras <strong>temos os valores de cada uma</strong>, sendo o total já lançado, o disponível e o limite de lançamento.',
          params: {
            placement: 'bottom',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="14"]',
          content: ' Clique em + Incluir, para adicionar uma nova despesa na carteira de Adiantamento.',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="15"]',
          content: 'Clique em + Incluir, para adicionar uma nova despesa na carteira de Recurso Próprio',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="16"]',
          content: 'Aqui fica a tabela com todas as suas transações e despesas das carteiras!',
          params: {
            placement: 'top',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="17"]',
          content: 'Observe aqui as pendências de cada movimentação.',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="18"]',
          content: 'Botão para justificar falta de despesa',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="19"]',
          content: 'Botão para incluir uma nova despesa',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="20"]',
          content: 'Botão para Visualizar a despesa',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="21"]',
          content: 'Botão para Editar a despesa',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: true
          }
        },
        {
          target: '[data-v-step="22"]',
          content: 'Botão para Excluir a despesa',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="23"]',
          content: 'Neste botão você ira conferir a quantidade de despesas na sua Transação',
          params: {
            placement: 'left',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="24"]',
          content: 'Essa é a tabela com todas as despesa(s) da transação',
          params: {
            placement: 'top',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="25"]',
          content: 'Aqui fica os veículo(s) utilizado(s) no seu projeto! Você pode conferir nesse card: A fabricante, modelo, período de utilização e a placa do veículo;Os KM Atual, Percorrido, Inicial e Final.',
          params: {
            placement: 'top',
            highlight: true,
            enableScrolling: true
          }
        },
        {
          target: '[data-v-step="26"]',
          content: 'Se você tiver mais de um veículo e gostaria de visualiza-los, é só clicar nessa seta e transicionar entre os veículos',
          params: {
            placement: 'right',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="27"]',
          content: 'Caso necessário, você pode editar o KM Final do seu veículo! Só clicar em Editar, alterar o valor e Salvar!',
          params: {
            placement: 'top',
            highlight: true,
            enableScrolling: true
          }
        },
        {
          target: '[data-v-step="28"]',
          content: 'Aqui fica suas Despesas de Combustivel',
          params: {
            placement: 'top',
            highlight: true,
            enableScrolling: true
          }
        },
        {
          target: '[data-v-step="29"]',
          content: 'Clique aqui para incluir a Km de uso particular do veículo, caso a Unicampo tenha liberado esse uso.',
          params: {
            placement: 'top',
            highlight: true,
            enableScrolling: true
          }
        },
        {
          target: '[data-v-step="30"]',
          content: 'Nesse card você consegue analisar  os maiores gastos do RDV, divididos entre total por Despesa e Totel por Categoria, clique nos botões para alterar!',
          params: {
            placement: 'top',
            highlight: true,
            enableScrolling: true
          }
        }
      ]
    },
	}
}
